import {
  CheckCircle as ActiveIcon,
  Schedule as ScheduledIcon,
  Stop as StoppedIcon,
  EditNote as DraftIcon,
} from '@mui/icons-material';

export const getStatusIcon = status => {
  switch (status?.toLowerCase()) {
    case 'active':
      return <ActiveIcon color="success" />;
    case 'draft':
      return <DraftIcon color="default" />;
    case 'paused':
      return <ScheduledIcon color="warning" />;
    case 'stopped':
    case 'completed':
      return <StoppedIcon color="error" />;
    default:
      return <ScheduledIcon color="default" />;
  }
};

export const getStatusColor = status => {
  switch (status?.toLowerCase()) {
    case 'active':
      return 'success';
    case 'draft':
      return 'default';
    case 'paused':
      return 'warning';
    case 'stopped':
    case 'completed':
      return 'error';
    default:
      return 'default';
  }
};

export const formatDate = dateString => {
  if (!dateString) return 'N/A';
  try {
    return new Date(dateString).toLocaleString();
  } catch {
    return dateString;
  }
};

export const formatTrafficAllocation = (allocation, treatments) => {
  if (allocation === 'equal_split' && treatments) {
    const percentage = Math.round(100 / treatments.length);
    return treatments.map(t => `${t.name}: ${percentage}%`).join(', ');
  }
  if (typeof allocation === 'object') {
    return Object.entries(allocation)
      .map(([name, value]) => `${name}: ${value}%`)
      .join(', ');
  }
  return allocation || 'N/A';
};
